module.exports = __webpack_public_path__ + "img/SCB_Logo_White.df5b7c52.png";